import { withInstall } from '@element-plus/utils/with-install'

import PageHeader from './src/page-header.vue'

export const ElPageHeader = withInstall(PageHeader)
export default ElPageHeader

export * from './src/page-header'
